import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function useActivity(params?: Record<string, string>) {
  return useQuery({
    queryKey: ['activity', params],
    queryFn: () => apiClient.get('/activity', params),
  });
}
